// set logic stuff

export function union(setA, setB) {
  return new Set([...setA, ...setB]);
}

export function intersection(setA, setB) {
  return new Set(Array.from(setA).filter((e) => setB.has(e)));
}

export function difference(setA, setB) {
  return new Set(Array.from(setA).filter((e) => !setB.has(e)));
}

export function isEqual(a, b) {
    return a.size === b.size && intersection(a, b).size === a.size
}


export function radioCorrectness(correctSet, incorrectSet, selectedSet) {
    return intersection(correctSet, selectedSet).size > 0
}

export function logicalOrCorrectness(correctSet, incorrectSet, selectedSet) {
    return (
      intersection(correctSet, selectedSet).size > 1 &&
      intersection(incorrectSet, selectedSet).size === 0
    );
}

export function logicalAndCorrectness(correctSet, incorrectSet, selectedSet) {
    return isEqual(correctSet, selectedSet)
}
